// Năm cuộc thi hiện hành. Đổi REACT_APP_COMPETITION_YEAR trong .env mỗi mùa thi mới.
export const COMPETITION_YEAR: number =
  parseInt(process.env.REACT_APP_COMPETITION_YEAR || '', 10) || 2027;
